import { render, staticRenderFns } from "./TgHandicapDialog.vue?vue&type=template&id=298e9b34"
import script from "./TgHandicapDialog.vue?vue&type=script&lang=js"
export * from "./TgHandicapDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports